// extracted by mini-css-extract-plugin
export default {"root":"SectionConditionTags_root__MxWBO","conditionLabel":"SectionConditionTags_conditionLabel__5FBLj","conditionBadge":"SectionConditionTags_conditionBadge__c0seX"};